import React from "react";
import { useSelector } from "react-redux";
import {
  makeStyles,
  Grid,
  Typography,
  Box,
  Button,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import { grey100 } from "material-ui/styles/colors";
import { Skeleton, Alert } from "@material-ui/lab";
import { DropzoneArea } from "material-ui-dropzone";
import { withStyles } from "@material-ui/core/styles";
import { trackingrequest } from "../service/service";
import EDropzone from "./_dropzone";
import { config } from "../../../../enviroment";
import { useTranslation } from "react-i18next";
import EDocumentVerfication from "./_document_inprogress";
import Snackbar from "@material-ui/core/Snackbar";
import { SnackbarProvider, useSnackbar } from "notistack";
export const CustomDropZone = withStyles((theme) => ({
  textContainer: {
    color: theme.palette.ePastelColor2?.base,
  },
  text: {
    margin: "2% 0% 0.8% 0%",
    color: theme.palette.ePrimary?.base,
    fontSize: "0.75rem",
  },
  icon: {
    color: theme.palette.ePrimary?.base,
    marginBottom: "1.5%",
  },
  root: {
    marginTop: "1%",
    minHeight: "55%",
    width: "75%",
    align: "center",
  },
}))(DropzoneArea);
const useStyle = makeStyles((theme) => ({
  image: {
    margin: "1rem",
  },
  box: {
    justify: "center",
    backgroundColor: grey100,
    border: "1px dashed" + theme?.palette?.eRich?.base,
    margin: "1rem",
  },
  technicalLabel: {
    fontWeight: "bold",
  },
  inProgressLabel: {
    color: theme?.palette?.eTertiary?.base,
    fontWeight: "bold",
  },
  content1: {
    marginTop: "2rem",
    color: theme?.palette?.eSecondary?.base,
  },
  content1: {
    marginTop: "2rem",
    color: theme?.palette?.eSecondary?.base,
  },
  revistContent: {
    color: theme?.palette?.ePrimary?.base,
    fontWeight: "bold",
    margin: "1rem",
  },
  error: {
    color: theme?.palette?.eDanger?.dark,
  },
  previewChip: {
    paddingTop: "2% !important",
    paddingBottom: "1% !important",
    wordWrap: "break-word !important",
    whiteSpace: "normal !important",
  },
  hr: {
    width: "75%",
    color: theme?.palette?.ePrimary?.base + "!important",
    fontWeight: "bold",
    marginLeft: "13%",
    height: "2px",
  },
  paymentButton: {
    backgroundColor: theme?.palette?.eSecondary?.base,
    color: theme?.palette?.eWhite?.base,
    borderRadius: 29,
    "&:hover": {
      backgroundColor: theme?.palette?.ePrimary?.hover,
      color: theme?.palette?.eWhite?.base,
    },
    [theme.breakpoints.down("sm")]: {
      width: "38vw",
      align: "center",
    },
    [theme.breakpoints.up("md")]: {
      width: "8vw",
    },
    marginTop: "2%",
  },
  marginButton: {
    marginRight: "6%",
    marginTop: "2%",
  },
  disabledSubmitButton: {
    background: theme?.palette?.eLight?.base + "!important",
    borderRadius: 29,
    [theme.breakpoints.down("sm")]: {
      width: "38vw",
      align: "center",
    },
    [theme.breakpoints.up("md")]: {
      width: "8vw",
    },
    marginTop: "2%",
  },
  spinnerStyling: {
    color: theme?.palette?.eWhite?.base + " !important",
  },
  alertMessage: {
    // margin: "0% 14%",
    padding: "0% 1%",
    color: theme?.palette?.eWhite?.base,
    backgroundColor: theme?.palette?.eSecondary?.base,
    fontSize: "0.68rem",
    justifyContent: "center",
  },
  content: {
    margin: "2rem",
  },
  flow: { overflow: "auto", marginTop: "2%" },
  flow1: {
    color: theme?.palette?.eDanger?.dark + " !important",
    marginLeft: "13%",
  },
  redColorAlert: {
    color: theme.palette.eDanger?.dark + " !important",
    border: "1px solid " + theme.palette.eDanger?.dark,
  },
  greenColorAlert: {
    color: theme.palette.eWhite?.base + " !important",
    border: "1px solid " + theme.palette.eSecondary?.base,
    backgroundColor: theme.palette.eSecondary?.base + " !important",
    "& .MuiSvgIcon-fontSizeInherit": {
      color: theme.palette.eWhite?.base + " !important",
    },
  },
}));

export default function EDocumentError({
  response,
  trackingCaseId,
  documentsUploaded,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const tenantCode = config.parameters.TENANT_CODE;
  let labels = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_STREET_LIGHT_SERVICE
  );
  const trackClass = useStyle();

  const [fileTypes, setFileTypes] = useState([]);
  let DUPLICATE_FILE_MESSAGE = useSelector(
    (state) =>
      state?.labels?.data?.getLabels?.E_SUPPORT_COMPLAINTS
        ?.E_COMPLAINTS_DUPLICATE_FILES_ERROR
  );
  const MAX_FILE_SIZE = parseInt(
    useSelector(
      (state) =>
        state?.parametersWidgets?.ParameterLookup
          ?.SERVICE_REQUEST_MAX_FILES_ALLOWED
    )
  );
  let MAX_FILES_ALLOWED_MESSAGE =
    labels?.E_STREET_LIGHT_REQUEST_MAX_FILES_ERROR;
  let MAX_FILES_ALLOWED_PARAMETER = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup
        ?.SERVICE_REQUEST_MAX_FILES_ALLOWED
  );
  MAX_FILES_ALLOWED_MESSAGE = MAX_FILES_ALLOWED_MESSAGE?.replaceAll(
    "**",
    MAX_FILES_ALLOWED_PARAMETER
  );
  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );

  const [selectedFiles, setSelectedFiles] = useState([]);

  const [allAttachedFiles, setAllAttachedFiles] = useState([]);
  const [responsedata, setResponse] = useState(false);
  const [reset, setReset] = useState();
  const [data, setData] = useState();
  const [inprogress, setInprogress] = useState(false);
  const [error, setError] = useState(false);
  const { t: labelss, ready: labelReady } = useTranslation(
    "label-E_TRACKING_NEW_CONNECTION"
  );
  const { t: contentdata, ready: contentdataReady } = useTranslation(
    "content-E_TRACKING_NEW_CONNECTION"
  );
  const [open, setOpen] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handler = () => {
    if (trackingCaseId) {
      setResponse(true);
      trackingrequest
        .createTrackingRequestUpdate(
          tenantCode,
          languageCode,
          trackingCaseId,
          selectedFiles
        )
        .then(
          (res) => {
            setResponse(false);
            setData(
              res?.data?.createTrackingRequestUpdate?.status?.statusMessage
            );
            setOpen(true);
            setReset(true);
            setTimeout(() => {
              setInprogress(true);
            }, 6000);
          },
          (error) => {
            setResponse(false);
            if (error) {
              setError(true);
              setOpen(true);
            }else{
              setError(false);
            }
          }
        )
        .catch((error) => {
          setResponse(false);
        });
    }
  };
  const [disable, setDisable] = useState(true);
  const { t: titlelabels, ready: titlelabelsReady } = useTranslation(
    "label-NESCO_TRACK_REQUEST"
  );
  useEffect(() => {
    if (response?.missingDoc.length === selectedFiles.length) {
      setDisable(false);
    } else if(!Array.isArray(response?.missingDoc) && selectedFiles.length>0){
      setDisable(false);
    }
     else {
      setDisable(true);
    }
  }, [selectedFiles]);
  return (
    <>
      {documentsUploaded?.documentsUploaded === true || inprogress === true ? (
        <EDocumentVerfication />
      ) : (
        <Grid container justify="center">
          <Grid container justify="center">
            {contentdataReady ? (
              <Typography variant="body2" className={trackClass.content}>
                {contentdata("E_TRACKING_DOC").answer}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          {response?.missingDoc && Array.isArray(response?.missingDoc) ? (response?.missingDoc?.map((item, index) => (
            <>
              <Grid
                conatiner
                xs={12}
                sm={12}
                md={6}
                className={trackClass.flow}
              >
                <Typography align="left" className={trackClass.flow1}>
                  {item.docname}
                </Typography>
                <Divider className={trackClass.hr} />
                <Grid align="center">
                  <EDropzone
                    fileName={item.docname}
                    index={index}
                    selectedFiles={selectedFiles}
                    setSelectedFiles={setSelectedFiles}
                    allAttachedFiles={allAttachedFiles}
                    setAllAttachedFiles={setAllAttachedFiles}
                    attachmentFor={item.docname}
                    reset={reset}
                  />
                </Grid>
              </Grid>
            </>
          ))):( <>
            <Grid
              conatiner
              xs={12}
              sm={12}
              md={6}
              className={trackClass.flow}
            >
              <Typography align="left" className={trackClass.flow1}>
                {response?.missingDoc?.docname}
              </Typography>
              <Divider className={trackClass.hr} />
              <Grid align="center">
                <EDropzone
                  fileName={response?.missingDoc?.docname}
                  index={0}
                  selectedFiles={selectedFiles}
                  setSelectedFiles={setSelectedFiles}
                  allAttachedFiles={allAttachedFiles}
                  setAllAttachedFiles={setAllAttachedFiles}
                  attachmentFor={response?.missingDoc?.docname}
                  reset={reset}
                />
              </Grid>
            </Grid>
          </>)}
          <Grid>
            {data ? (
              <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                open={open}
                onClose={handleClose}
                autoHideDuration={6000}
              >
                <Alert
                  onClose={handleClose}
                  severity="success"
                  sx={{ width: "100%" }}
                  className={trackClass.greenColorAlert}
                >
                  {labelReady ? (
                    labelss("E_DOC_SUCCESS")
                  ) : (
                    <Skeleton variant="rectangle" animation="wave"></Skeleton>
                  )}
                </Alert>
              </Snackbar>
            ) : (
              ""
            )}
            {error ? (
              <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
              >
                <Alert
                  severity="error"
                  sx={{ width: "100%" }}
                  onClose={handleClose}
                  className={trackClass.redColorAlert}
                >
                  {labelReady ? (
                    labelss("E_DOC_FAIL")
                  ) : (
                    <Skeleton variant="rectangle" animation="wave"></Skeleton>
                  )}
                </Alert>
              </Snackbar>
            ) : (
              ""
            )}
          </Grid>
          <Grid
            container
            justify="flex-end"
            className={trackClass.marginButton}
          >
            <Button
              className={
                disable
                  ? trackClass.disabledSubmitButton
                  : trackClass.paymentButton
              }
              align="left"
              onClick={handler}
              disabled={disable}
            >
              {titlelabelsReady ? titlelabels("E_TRACKING_SUBMIT") : ""}{" "}
              {responsedata && (
                <CircularProgress
                  size={15}
                  className={trackClass.spinnerStyling}
                />
              )}
            </Button>
          </Grid>
        </Grid>
      )}
    </>
  );
}
